export const ErrorReason = {
  Unauthorized: 'unauthorized',
  NotFound: 'not-found',
} as const;

export type ErrorReason = (typeof ErrorReason)[keyof typeof ErrorReason];
